<template>
    <div class="kindergarten-services-area bg-f7ebeb pt-100">
        <div class="container">
            <div class="section-title" v-for="title of titles" :key="title.title_id">
                <span class="sub-title">{{ title.title_title }}</span>
                <h2 class="font-weight-black">{{ title.title_header }}</h2>
                <p>{{ title.title_content }}</p>
            </div>
            <div class="services-slides">
                <carousel :autoplay="5000" :settings='settings' :breakpoints='breakpoints' :wrap-around="true">
                    <Slide v-for="service in services" :key="service.service_id">
                        <div class="single-kindergarten-services-box">
                            <img src="../../assets/img/shape/box-shape1.png" alt="service border">
                            <div class="content">
                                <div class="icon">
                                    <img :src="getImgUrl('hizmetler', service.service_img)" :alt="service.service_header"
                                        style="width: 55px;">
                                </div>
                                <h3 class="font-weight-black">{{ service.service_header }}</h3>
                                <p>{{ service.service_content }}</p>
                            </div>
                        </div>
                    </Slide>

                    <template #addons>
                        <Navigation />
                    </template>
                </carousel>
            </div>
            <div class="kids-kite-image">
                <img src="../../assets/img/kindergarten/kids-with-kite.png" alt="image">
            </div>
        </div>
        <div class="kindergarten-shape9">
            <img src="../../assets/img/kindergarten-shape/k-shape9.png" alt="image">
        </div>
        <div class="kindergarten-shape10">
            <img src="../../assets/img/kindergarten-shape/k-shape10.png" alt="image">
        </div>
    </div>
</template>

<script>

import axios from "axios";


import { defineComponent } from 'vue';
import { Carousel, Slide, Navigation } from 'vue3-carousel';

import 'vue3-carousel/dist/carousel.css';

export default defineComponent({
    name: 'BestServicesKids',
    props: ['pathUrl'],

    components: {
        Carousel,
        Slide,
        Navigation,
    },
    data: () => ({
        titles: [],
        services: [{ "service_id": 1, "service_situation": 1, "service_date": "2023-10-18 00:00:00", "service_img": "sports-training.png", "service_header": "Spor Gelişimi", "service_content": "Lorem ipsum dolor sit amet, ipsum adipiscing elit elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua quis ipsum." }],
        errors: [],

        settings: {
            itemsToShow: 1,
            snapAlign: 'center',
        },
        breakpoints: {
            0: {
                itemsToShow: 1,
                snapAlign: 'center',
            },
            576: {
                itemsToShow: 2,
                snapAlign: 'left',
            },
            768: {
                itemsToShow: 2,
                snapAlign: 'left',
            },
            992: {
                itemsToShow: 3,
                snapAlign: 'center',
            },
        },
    }),
    created() {
        this.getTitles();
        this.getServices();
    },
    methods: {
        getTitles() {
            axios.get(this.pathUrl + "?data=title&parent=4")
                .then(response => (this.titles = response.data.result))
                .catch(error => {
                    this.errors.push(error);
                });
        },
        getServices() {
            axios.get(this.pathUrl + "?data=service")
                .then(response => (this.services = response.data.result))
                .catch(error => {
                    this.errors.push(error);
                });
        },
        getImgUrl(category, pet) {
            return require('../../../../assets/resimler/' + category + '/' + pet)
        }
    },
})
</script>